
import request from '../../requests/requests';
import { Api } from '../../config/api';
import { configs } from '../../config/config';

export function getDashboardBatteryLow(data){
    return request({
        url:Api.dashboard.low_remind,
        method:configs.http.request.methodPost,
        data
    })
}

export function getDashboardBatteryOff(data){
    return request({
        url:Api.dashboard.off_remind,
        method:configs.http.request.methodPost,
        data
    })
}

// activation

export function getActivationList(data){
    return request({
        url:Api.dashboard.activation_group,
        method:configs.http.request.methodPost,
        data
    })
}

export function getActivationSum(data){
    return request({
        url:Api.dashboard.activation_sum,
        method:configs.http.request.methodPost,
        data
    })
}

//activity

export function getActivityPie(data){
    return request({
        url:Api.dashboard.activity_pie,
        method:configs.http.request.methodPost,
        data
    })
}

// device nums group by cid
export function getDeviceNumsByCid(data){
    return request({
        url:Api.dashboard.device_nums,
        method:configs.http.request.methodPost,
        data
    })
}

// daily activity
export function getDeviceActivityDaily(data){
    return request({
        url:Api.dashboard.activity_date,
        method:configs.http.request.methodPost,
        data
    })
}


// nfc charts request

export function GetNfcChartsData(data){
    return request({
        url:Api.dashboard.nfc_charts,
        method:configs.http.request.methodPost,
        data
    })
}

export function GetNfcChartsDataDate(data){
    return request({
        url:Api.dashboard.nfc_charts_date,
        method:configs.http.request.methodPost,
        data
    })
}

// index

export function GetBannerData(data){
    return request({
        url:Api.dashboard.banner,
        method:configs.http.request.methodPost,
        data
    })
}


export function GetKindData(data){
    return request({
        url:Api.dashboard.kind,
        method:configs.http.request.methodPost,
        data
    })
}






